export const languages = ['cs', 'en', 'sk'];
